import { AsyncThunkAction } from '@reduxjs/toolkit';
import {
	Filters,
	PaginationFilterPersonsContext,
	usePagination,
} from 'shared/lib/pagination';
import { FC, ReactNode } from 'react';

interface PaginationProviderProps {
	fetchData: (filters: Filters) => AsyncThunkAction<any, any, any>;
	children: ReactNode;
}

export const PaginationFilterPersonsProvider: FC<PaginationProviderProps> = ({
	fetchData,
	children,
}) => {
	const props = usePagination(fetchData);
	return (
		<PaginationFilterPersonsContext.Provider value={{ ...props }}>
			{children}
		</PaginationFilterPersonsContext.Provider>
	);
};
